// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3kPhH","approved":"Status_approved__2Rf36","rejected":"Status_rejected__38XfU","expired":"Status_expired__29xPW","label":"Status_label__6wBRu"};